<template>
  <header class="fixed-top" :class="{ 'navbar--hidden': !showNavbar }">
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mb-2 mb-lg-0">
              <li class="nav-item" v-for="(item, key) in items" :key="key">
                <a
                  class="nav-link link"
                  aria-current="page"
                  v-scroll-to="item.link"
                >
                  {{ item.name }}
                </a>
              </li>
            </ul>
            <button-simple primary v-scroll-to="'#order'" class="ms-auto">
              Купить
            </button-simple>
          </div>
        </div>
      </nav>
    </div>
    <!-- <div toggleable="md" type="light" class="container">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            :to="'/' + $store.getters.getCurrentLanguage.toLowerCase() + item.link"
            v-for="(item,key) in items"
            :key="key"
            @mouseover="$store.commit('set',{type:'hover',items:true})"
            @mouseout="$store.commit('set',{type:'hover',items:false})"
    >{{t(item.name)}}</b-nav-item>-->
    <!-- <b-nav-item-dropdown text="Services" right>
            <b-dropdown-item to="/services">CRM</b-dropdown-item>
            <b-dropdown-item href="#">Online Stores</b-dropdown-item>
            <b-dropdown-item href="#">Business Solutions</b-dropdown-item>
            <b-dropdown-item href="#">Websites</b-dropdown-item>
            <b-dropdown-item href="#">Blockchain</b-dropdown-item>
    </b-nav-item-dropdown>-->
    <!-- <button-rounded color='primary' @click="$store.dispatch('switchPopUp')">{{t('Get In Touch')}}</button-rounded>
          <b-nav-item-dropdown :text="$store.getters.getCurrentLanguage" right>
            <b-dropdown-item
              @click="changeLang(lang)"
              v-for="(lang,key) in languages"
              :key="key"
    >{{lang.name}}</b-dropdown-item>-->
    <!-- <b-dropdown-item to="/services">PL</b-dropdown-item>
    <b-dropdown-item to="/services">CZ</b-dropdown-item>-->
    <!-- </b-nav-item-dropdown>
        </b-navbar-nav>
    </b-collapse>-->
    <!-- </div> -->
    <div
      v-show="loading"
      class="loading-progress"
      :style="{ width: loadingPercent + '%' }"
    ></div>
  </header>
</template>

<script>
import buttonSimple from "../components/buttonSimple.vue";

export default {
  components: {
    buttonSimple,
  },
  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0,
      loadingPercent: 0,
      loadTime: 0,
      interval: null,
      loading: true,
      items: [
        {
          name: "О книге",
          link: "#about",
        },
        {
          name: "Авторы",
          link: "#authors",
        },
        {
          name: "О Савве",
          link: "#about-savva",
        },
        // {
        //   name: "Services",
        //   link: "/services",
        // },
        // {
        //   name: "Заказать",
        //   link: "#order",
        // },
        // {
        //   name: "Get in touch",
        //   link: "/about",
        // },
      ],
    };
  },
  methods: {
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // if (currentScrollPosition > 0) {
      //   return;
      // }
      // // Stop executing this function if the difference between
      // // current scroll position and last scroll position is less than some offset
      // if (currentScrollPosition > 0) {
      //   return;
      // }
      this.showNavbar = currentScrollPosition < 60;
      // this.lastScrollPosition = currentScrollPosition;
    },
    doProgress() {
      let step = this.loadTime / 100;
      this.interval = setInterval(() => {
        this.loadingPercent++;
      }, step);
    },
    changeLang(item) {
      console.log(item.value, this.$store.state.currentLanguage);
      this.$router.push({
        name: this.$route.name,
        params: { locale: item.value },
      });
      this.$store.commit("setCurrentLanguage", item);
      // this.$translate.setLang(item.value);
    },
  },
  created() {
    let perfData = window.performance.timing;
    let estimatedTime = Math.abs(
      perfData.loadEventEnd - perfData.navigationStart
    );
    this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
    this.doProgress();
  },
  watch: {
    loadingPercent(val) {
      if (val >= 100) {
        this.loading = false;
        clearInterval(this.interval);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },

  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.onScroll);
  // }
};
</script>

<style lang='scss'>
@import "../stylesheets/main.scss";
.loading-progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background: $primary;
}
header.navbar--hidden {
  background: rgba($light, 1);
  box-shadow: 0px 10px 20px rgba(31, 32, 65, 0.05);
  // .nav-item:last-child a{
  //   margin-right: 0;
  // }
  // .navbar-inner,.navbar-nav{
  //   transition: all 0.1s ease-in-out;
  // }
}
.b-nav-dropdown {
  cursor: none !important;
  * {
    cursor: inherit;
  }
}
header {
  background: rgba($light, 0);
  @media screen and (max-width: 576px) {
    background: rgba($light, 1);
  }
  box-shadow: 0px 10px 20px rgba(31, 32, 65, 0);
  transition: all 0.3s ease 0s;
  // padding: 20px 0;
  .dropdown {
    &.show {
      .dropdown-toggle {
        &::after {
          transform: rotate(135deg);
          margin-top: 0;
        }
      }
    }
    .dropdown-menu {
      min-width: initial;
    }
    .dropdown-toggle {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      &::after {
        display: block;
        width: 8px;
        height: 8px;
        margin-top: -2px;
        position: absolute;
        right: -2px;
        border: 2px solid $primary;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);
        transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
      }
    }
  }
  .navbar {
    // transition: all 0.3s ease 0s;
    padding-top: 16px;
    padding-bottom: 16px;
    // background: ;
    &-brand {
      transition: all 0.3s ease 0s;
      span {
        font-weight: 900;
      }
    }
    &-toggler {
      border: none;
      &-icon {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgb(255, 165, 0)' stroke-width='3' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
      }
    }
  }
  // .navbar-inner,.navbar-nav{
  //   transition: all 0.1s ease-in-out;
  // }
  .navbar-light {
    .navbar-nav {
      .nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &:last-child {
          a {
            margin-right: 0;
          }
        }
        .nav-link {
          cursor: pointer;
          // @extend %open-sans;
          margin-left: 5px;
          margin-right: 5px;
          padding: 0;
          color: rgba(#1f2041, 0.5);
          // font-weight: 300;
          position: relative;
          display: flex;
          align-items: center;
          font-size: 0.725rem;
          text-transform: uppercase;
          font-weight: 600;
          letter-spacing: 2px;
          // &::before {
          //   content: "";
          //   display: block;
          //   position: absolute;
          //   // bottom: 14px;
          //   left: -15px;
          //   // top: calc(1rem - 2.5px);
          //   margin-top: -2px;
          //   width: 5px;
          //   height: 5px;
          //   background: $secondary;
          //   opacity: .0;
          // }
          // &:hover::before {
          //   // background: $primary;
          //   opacity: 1;
          // }
          &:hover,
          &:focus,
          &:active {
            color: #1f2041;
            // font-weight: bold;
            &::before {
              // background: $primary;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>